import '@fortawesome/fontawesome-free/css/all.min.css';

import { createApp } from 'vue';
import axios from 'axios';
import '@/assets/main.css';

import DatePicker from '@/components/DatePicker.vue';

import money from 'v-money';
import Highcharts from 'highcharts';
import moment from 'moment';
import momentTz from 'moment-timezone';

import interceptorsSetup from '@/middleware/axios-interceptors';
import utils from '@/services/utils';
import ValidationProvider from '@/validation/ValidationProvider.vue';
import ValidationObserver from '@/validation/ValidationObserver.vue';
import setupValidation from '@/validation/setupValidation';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';
import logAppInfo from './plugins/appVersion';

const __g: any = globalThis as any;
if (!__g.__AMS_AXIOS_INTERCEPTORS_SETUP__) {
  __g.__AMS_AXIOS_INTERCEPTORS_SETUP__ = true;
  interceptorsSetup();
}

const app = createApp(App);

app.use(i18n);

const getT = () => {
  const g: any = (i18n as any).global;
  return (key: string, params?: Record<string, any>) => {
    if (!g?.t) return key;
    return (params ? g.t(key, params) : g.t(key)) as string;
  };
};

setupValidation(getT);

// ---------- Global Components / Plugins ----------
app.component('DatePicker', DatePicker as any);

app.component('ValidationProvider', ValidationProvider as any);
app.component('ValidationObserver', ValidationObserver as any);

(app.config.globalProperties as any).$axios = axios;
(app.config.globalProperties as any).axios = axios;
(app.config.globalProperties as any).$http = axios;

// v-money
app.use(money as any, {
  precision: 2,
  prefix: '',
  decimal: '.',
  thousands: ','
});

const currencyFormat = (value: any, opt?: { decimals?: number; thousands?: string; decimal?: string }) => {
  const n = Number(value ?? 0);
  const decimals = Number(opt?.decimals ?? 2);
  const thousands = String(opt?.thousands ?? ',');
  const decimal = String(opt?.decimal ?? '.');

  if (!Number.isFinite(n)) return String(value ?? '');

  const fixed = n.toFixed(decimals);
  const [intPart, decPart] = fixed.split('.');
  const withSep = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
  return decPart ? `${withSep}${decimal}${decPart}` : withSep;
};

// keep old patterns alive
(app.config.globalProperties as any).$currency = currencyFormat;
(app.config.globalProperties as any).currency_usd = (v: any) => currencyFormat(v, { decimals: 4 });

momentTz.tz.setDefault('Asia/Hong_Kong');
app.config.globalProperties.$moment = moment;

Highcharts.setOptions({ lang: { thousandsSep: ',' } });

// Auth Header
const userPersistent = utils.getUserPersistent();
if (userPersistent.token) {
  axios.defaults.headers.common.Authorization = `Bearer ${userPersistent.token}`;
}

app.use(router);
app.use(store);
logAppInfo();

router.isReady().then(() => {
  app.mount('#app');
});
